import { snakeCaseKeys } from '../apiTransformers/transformers';
import isObject from 'lodash/isObject';
/**
 * SnakeCase decorator - transrofms keys in your Request to snakeCase
 * @param function
 * @returns function
 ```
  import { SnakeCaseRequest } from '../../_decorators';

  @SnakeCaseRequest
  getVehicleSummary(vehicleVin: string): Promise<Component[]> {

  ```
 */
export function SnakeCaseRequest(target, propertyName, propertyDescriptor) {
    const method = propertyDescriptor.value;
    propertyDescriptor.value = (...args) => {
        const params = args.map(param => isObject(param) ? snakeCaseKeys(param, propertyName) : param);
        return method.apply(target, params);
    };
    return propertyDescriptor;
}
